import httpClient from "@/httpClient"
import formatForApi from "@/js/filters/formatForApi"

const getCurrentUser = (company) => httpClient.get(`${company || '{currentCompanySlug}'}/user/profile`)
const saveUserAvatar = (file) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/user/profile/avatar',
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const saveUserAvatarById = ({ accountId, file }) => httpClient({
  method: 'POST',
  url: `{currentCompanySlug}/company-accounts/${accountId}/avatar`,
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const saveTenantAdminAvatarById = ({ companyTenant, accountId, file }) => httpClient({
  method: 'POST',
  url: `tenant-admin/${companyTenant}/users/${accountId}/avatar`,
  data: file,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const changeUserStatus = (payload) => {
  return httpClient.post('/user/profile/status', payload ? {
    name: payload.name,
    expiresAt: formatForApi(payload.expiresAt),
  } : {
    name: null,
  })
}
const getUserTypes = () => httpClient.get(`{currentCompanySlug}/company-accounts/types`)
const getUserPermissions = () => httpClient.get('/permissions')
const getUsers = ({ params = {}, company } = {}) => {
  let perPage = 10
  if (params.userIds) {
    const userIdsLength = params.userIds.split('|').length
    perPage = perPage < userIdsLength ? userIdsLength : perPage
  }

  return httpClient.get(`${company || '{currentCompanySlug}'}/company-accounts`, {
    params: {
      ...params,
      per_page: perPage,
    },
  })
}
const getUser = ({ id }) => httpClient.get(`{currentCompanySlug}/company-accounts/${id}`)
const createUser = ({ payload }) => httpClient.post(`{currentCompanySlug}/company-accounts`, payload)
const editUser = ({ id, payload }) => httpClient.patch(`{currentCompanySlug}/company-accounts/${id}`, payload)
const activateUser = (id) => httpClient.patch(`{currentCompanySlug}/users/suppliers/${id}/activate`)
const deactivateUser = (id) => httpClient.patch(`{currentCompanySlug}/users/suppliers/${id}/deactivate`)
const resetPassword = (id) => httpClient.patch(`{currentCompanySlug}/users/suppliers/${id}/reset-password`)
const getAccountsRecords = ({ id }) => httpClient.get(`{currentCompanySlug}/accounts/${id}/records`)
const removeAccountsRecords = ({ id, recordIds = []}) =>
  httpClient.post(`{currentCompanySlug}/accounts/${id}/records/remove`, {recordIds: recordIds})
const addAccountsRecords = ({ id, recordIds = []}) =>
  httpClient.post(`{currentCompanySlug}/accounts/${id}/records/add`, {recordIds: recordIds})

const exportUsers = (search) => httpClient.post(`{currentCompanySlug}/company-accounts/export`, search)
const importUsers = (payload) => httpClient({
  method: 'POST',
  url: '{currentCompanySlug}/company-accounts/import/upsert',
  data: payload,
  headers: { 'Content-Type': 'multipart/form-data' },
})

const downloadCsvExample = () => httpClient({
  method: 'GET',
  url: '{currentCompanySlug}/company-accounts/import/template',
  responseType: 'blob',
})

const deleteUserAvatar = () => httpClient.delete('{currentCompanySlug}/user/profile/avatar')

const deleteUserAvatarById = (accountId) => httpClient.delete(`{currentCompanySlug}/company-accounts/${accountId}/avatar`)

const deleteTenantAdminAvatarById = ({ companyTenant, accountId }) => httpClient.delete(`tenant-admin/${companyTenant}/users/${accountId}/avatar`)

const disconnectOutlookIntegration = (payload) => httpClient.post(`{currentCompanySlug}/outlook/disconnect`, payload)

export default {
  getCurrentUser,
  getUserTypes,
  getUserPermissions,
  saveUserAvatar,
  saveUserAvatarById,
  saveTenantAdminAvatarById,
  deleteUserAvatar,
  deleteUserAvatarById,
  deleteTenantAdminAvatarById,
  changeUserStatus,
  getUsers,
  getUser,
  createUser,
  editUser,
  activateUser,
  deactivateUser,
  resetPassword,
  getAccountsRecords,
  removeAccountsRecords,
  addAccountsRecords,
  exportUsers,
  importUsers,
  downloadCsvExample,
  disconnectOutlookIntegration,
}
